import { jsx as _jsx } from "react/jsx-runtime";
// Importing components
import { Player } from './components/player';
// Importing providers
import { DataProvider } from './providers/data';
import { I18nProvider } from './providers/i18n';
import { ThemeProvider } from './providers/theme';
// Importing 3rd party dependencies
import { createRoot } from 'react-dom/client';
// ----------------------------------------------------------------------
const CbaPlayer = () => {
    return (_jsx(DataProvider, { children: _jsx(I18nProvider, { children: _jsx(ThemeProvider, { children: _jsx(Player, {}) }) }) }));
};
// ----------------------------------------------------------------------
const rootElement = document.getElementById('cba-player');
if (rootElement) {
    createRoot(rootElement).render(_jsx(CbaPlayer, {}));
}
